import { Component, OnInit, Input } from '@angular/core';
import moment from 'moment';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-employment-overview',
  templateUrl: './employment-overview.component.pug',
  styleUrls: ['./employment-overview.component.scss'],
  standalone: false
})
export class EmploymentOverviewComponent implements OnInit {
  @Input() employeeData: any;
  @Input() managerData: any;
  @Input() requesterData: any;
  @Input() checkExitData: any;
  moment: any;
  endDateAmendment: any[] = [];
  startDateAmendment: any[] = [];
  exitEndDate: any;
  employeeStartDate: any;
  employeeEndDate: any;
  empStartDate: any;
  empEndDate: any;


  constructor(private permissions:PermissionsService) {}

  ngOnInit(): void {
    if (this.employeeData?.start_date) {
      // this.empStartDate = moment(this.employeeData.start_date).format('YYYY-MM-DD');
      this.empStartDate = moment(this.employeeData.start_date).format('MMM, YYYY');
    } else {
      this.empStartDate = '';
    }

    if (this.employeeData?.end_date) {
      // this.empEndDate = moment(this.employeeData.end_date).format('YYYY-MM-DD');
      this.empEndDate = moment(this.employeeData.end_date).format('MMM, YYYY');
    } else {
      this.empEndDate = '';
    }
    this.initAmendmentData();
  }

  initAmendmentData() {
    this.employeeEndDate = moment(this.employeeData.end_date).format('YYYY-MM-DD');
    this.employeeStartDate = moment(this.employeeData.start_date).format('YYYY-MM-DD');

    if (this.managerData) {
      this.managerData.forEach(man => {
        if (man.start_date) {
          let manStartDate = moment(man.start_date).format('YYYY-MM-DD');

          if (!this.compareDates(manStartDate, this.employeeStartDate)) {
            this.startDateAmendment.push({
              'name': man.name,
              'month': moment(manStartDate).format('MMMM'),
              'year': moment(manStartDate).format('YYYY') 
            })
          }
        }

        if (man.end_date) {
          let manEndDate = moment(man.end_date).format('YYYY-MM-DD');

          if (!this.compareDates(manEndDate, this.employeeEndDate)) {
            this.endDateAmendment.push({
              'name': man.name,
              'month': moment(manEndDate).format('MMMM'),
              'year': moment(manEndDate).format('YYYY')
            })
          }
        }
      });
    }
  }

  compareDates(a: any, b: any) {
    let aMonth = moment(a).format('MM');
    let aYear = moment(a).format('YYYY');

    let bMonth = moment(b).format('MM');
    let bYear = moment(b).format('YYYY');

    if (aMonth !== bMonth || aYear !== bYear) {
      return false;
    }
    return true;
  }
}
